<template>
  <div class="m-zones-settings">
    <r-panel-header title="Параметры слоя" />
    <div class="m-zones-settings__container">
      <color-control
        :id="id"
        :config="stylesConfigs.style.paint"
        color-field="fill-color"
        opacity-field="fill-opacity"
      />
      <outline-control
        :id="id"
        type="zones"
        :config="stylesConfigs.borderStyle.paint"
        color-field="line-color"
        opacity-field="line-opacity"
        width-field="line-width"
      />
      <popup-control :id="id" />
    </div>
  </div>
</template>

<script>
import ColorControl from '../controls/color'
import OutlineControl from '../controls/outline'
import PopupControl from '../controls/popup'

export default {
  components: {
    ColorControl,
    PopupControl,
    OutlineControl
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  computed: {
    stylesConfigs() {
      return this.$store.state.modelling.stylesConfigs[this.id]
    }
  }
}
</script>

<style lang="scss">
.m-zones-settings {
  flex: 1;
  display: flex;
  flex-direction: column;

  &__container {
    flex: 1;
    height: 0px;
    padding: 8px;
  }
}
</style>
